export default function WhyEmployeesDontSell() {
  const reasons = [
    { icon: 'ri-file-copy-line', title: 'Нет системы продаж', desc: 'Отсутствуют единые стандарты, скрипты и регламенты. Каждый менеджер действует интуитивно, результат непредсказуем.' },
    { icon: 'ri-question-mark', title: 'Не умеют выявлять потребности', desc: 'Менеджеры презентуют продукт, не поняв истинных болей клиента. Продажа начинается не с презентации, а с вопроса.' },
    { icon: 'ri-emotion-sad-line', title: 'Боятся цены', desc: 'Внутренний страх, что «дорого» = «не купят». Без уверенности в ценности продукта менеджер не может её донести до клиента.' },
    { icon: 'ri-phone-line', title: 'Не слышат клиента', desc: 'Говорят больше, чем слушают. Активное слушание — базовый навык, которым владеют единицы.' },
    { icon: 'ri-file-list-3-line', title: 'Работают по шаблону', desc: 'Механическое проговаривание скрипта без адаптации к ситуации. Шаблон — инструмент, а не замена мышлению.' },
    { icon: 'ri-user-search-line', title: 'Нет наставничества', desc: 'Руководитель не развивает команду, а только требует план. Без регулярной обратной связи навыки не растут.' },
    { icon: 'ri-book-read-line', title: 'Не знают продукт', desc: 'Поверхностное знание продукта не позволяет аргументировать ценность и отвечать на сложные вопросы клиентов.' },
    { icon: 'ri-chat-check-line', title: 'Нет обратной связи', desc: 'Отсутствует система контроля качества звонков и встреч. Менеджеры годами повторяют одни и те же ошибки.' },
    { icon: 'ri-bar-chart-box-line', title: 'Нет контроля качества', desc: 'Руководитель не слушает звонки, не читает переписки. Без аудита невозможно понять, где теряются продажи.' },
  ];

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему сотрудники не продают: <strong>настоящие причины</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Прежде чем записывать команду на <strong>корпоративный тренинг по продажам</strong>, важно понять корневые причины низких результатов. Вот что мы выявляем на этапе диагностики.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 hover:bg-teal-50 hover:shadow-md transition-all duration-300 group cursor-default">
              <div className="w-11 h-11 bg-white rounded-lg flex items-center justify-center mb-4 shadow-sm group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${item.icon} text-lg text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-teal-50 rounded-2xl p-8 max-w-4xl mx-auto text-center">
          <p className="text-lg text-gray-800 leading-relaxed mb-0">
            <strong>Главная мысль:</strong> тренинг сам по себе не меняет продажи. Продажи меняет система: <strong>диагностика → обучение → внедрение → сопровождение</strong>. Если убрать хотя бы один элемент — результат будет нулевым.
          </p>
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Получить бесплатную диагностику
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}